/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import Paper from "@mui/material/Paper";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import TextField from "components/TextFieldInput";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import {
  StyledTableRow,
  StyledTableRow1,
  StyledTableRow2,
  WorkOrderHeading,
  StyledDisabledByDefaultIcon,
  TextAreaWrapper,
} from "styles/pages/order";
import TagsAutocomplete from "components/TagsAutocomplete";
import {
  DECORATIONS,
  PROD_IMAGE_LIBRARY,
  THUMB_IMAGE_LIBRARY,
} from "constants/services";
import CustomAutocomplete from "components/Autocomplete";
import UploadImageWithLibrary from "components/UploadImageWithLibrary";
// import { useFetch } from "hooks/useFetch";
// import { useEffect, useState } from "react";

const SalesOrderLineItems = ({ state, setState }) => {
  // const [decorations, setDecorations] = useState([]);

  // const { refetch } = useFetch(DECORATIONS, DECORATIONS, {
  //   enabled: false,
  // });

  // useEffect(() => {
  //   const fetchDecorations = async () => {
  //     const { data } = await refetch();
  //     setDecorations(data);
  //   };
  //   fetchDecorations();
  // }, []);

  const lineItems = state?.lineItems;

  const handleLineItemsChange = (key, value, index) => {
    setState({
      ...state,
      lineItems: lineItems?.map((row, j) => {
        if (index !== j) return row;
        return {
          ...row,
          [key]: value,
        };
      }),
    });
  };

  const handleDecorationChange = (
    key,
    value,
    lineItemIndex,
    decorationIndex
  ) => {
    setState({
      ...state,
      lineItems: lineItems?.map((row, j) => {
        if (lineItemIndex !== j) return row;
        return {
          ...row,
          decorations: row?.decorations?.map((decoration, k) => {
            if (decorationIndex !== k) return decoration;
            return {
              ...decoration,
              [key]: value,
            };
          }),
        };
      }),
    });
  };

  const handleDeleteDecoration = (lineItemIndex, decorationIndex) => {
    setState({
      ...state,
      lineItems: lineItems?.map((row, j) => {
        if (lineItemIndex !== j) return row;
        return {
          ...row,
          decorations: row?.decorations?.filter(
            (decoration, k) => k !== decorationIndex
          ),
        };
      }),
    });
  };

  return (
    <Paper elevation={3}>
      <WorkOrderHeading>
        <div>Line Items</div>

        <AddCircleIcon
          sx={{ cursor: "pointer" }}
          onClick={() =>
            setState({
              ...state,
              lineItems: [{ taxPercentage: 13 }, ...lineItems],
            })
          }
        />
      </WorkOrderHeading>
      {lineItems?.map((row, i) => {
        const key = i;
        return (
          <StyledTableRow
            key={`editedLineItems_${key}`}
            even={i % 2 === 0}
            style={{
              borderBottom: "1px dashed #000",
            }}
          >
            <div style={{ position: "relative", height: 40 }}>
              <StyledDisabledByDefaultIcon
                onClick={() =>
                  setState({
                    ...state,
                    lineItems: lineItems?.filter((r, j) => i !== j),
                  })
                }
              />

              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ position: "absolute", top: 0, right: 20 }}
                onClick={() => {
                  setState({
                    ...state,
                    lineItems: [{ ...row, taxPercentage: 13 }, ...lineItems],
                  });
                }}
              >
                Clone
              </Button>
            </div>

            <StyledTableRow1>
              <TextField
                label="Description"
                error={!row?.description?.trim()}
                value={row?.description}
                handleChange={(e) =>
                  handleLineItemsChange("description", e?.target?.value, i)
                }
              />
            </StyledTableRow1>

            <StyledTableRow2>
              <TextField
                label="Quantity"
                error={!row?.qty}
                value={row?.qty}
                type="number"
                handleChange={(e) => {
                  if (Number(e?.target?.value) < 0) {
                    return;
                  }

                  const qty = Number(e?.target?.value);
                  const decorationCost = Number(row?.decorationCost) || 0;
                  const taxPercentage = Number(row?.taxPercentage) || 0;
                  const taxCharged =
                    decorationCost * qty * (taxPercentage / 100) || 0;
                  const chargeAmount = decorationCost * qty + taxCharged;
                  setState({
                    ...state,
                    lineItems: lineItems?.map((r, j) => {
                      if (i !== j) return r;
                      return {
                        ...r,
                        decorationCost,
                        taxCharged,
                        chargeAmount,
                        qty,
                      };
                    }),
                  });
                }}
                // handleChange={(e) =>
                //   handleLineItemsChange("qty", Number(e?.target?.value), i)
                // }
              />

              <TextField
                label="Color"
                error={!row?.color?.trim()}
                value={row?.color}
                handleChange={(e) =>
                  handleLineItemsChange("color", e?.target?.value, i)
                }
              />

              {/* <TextField
                label="Size"
                error={!row?.size?.trim()}
                value={row?.size}
                handleChange={(e) =>
                  handleLineItemsChange("size", e?.target?.value, i)
                }
              /> */}

              <CustomAutocomplete
                label="Size"
                value={row?.size}
                setValue={(c) => {
                  handleLineItemsChange("size", c, i);
                }}
                inputValue={row?.sizeInputValue}
                setInputValue={(v) => {
                  handleLineItemsChange("sizeInputValue", v, i);
                }}
                options={[
                  { id: "YXS", label: "YXS" },
                  { id: "YSM", label: "YSM" },
                  { id: "YMD", label: "YMD" },
                  { id: "YLG", label: "YLG" },
                  { id: "YXL", label: "YXL" },
                  { id: "Y2XL", label: "Y2XL" },
                  { id: "Y3XL", label: "Y3XL" },
                  { id: "Y4XL", label: "Y4XL" },
                  { id: "Y5XL", label: "Y5XL" },
                  { id: "AXS", label: "AXS" },
                  { id: "AS", label: "AS" },
                  { id: "AM", label: "AM" },
                  { id: "AL", label: "AL" },
                  { id: "AXL", label: "AXL" },
                  { id: "A2XL", label: "A2XL" },
                  { id: "A3XL", label: "A3XL" },
                  { id: "A4XL", label: "A4XL" },
                  { id: "A5XL", label: "A5XL" },
                  { id: "OSFA", label: "OSFA" },
                ]}
              />

              <TagsAutocomplete
                multiple={false}
                optionApiKey="decoCode"
                apiEndPoint={DECORATIONS}
                value={row?.decoration || { title: "", value: "" }}
                setValue={(decoration) => {
                  handleLineItemsChange(
                    "decoration",
                    {
                      title: decoration?.title || "",
                      value: decoration?.value || "",
                    },
                    i
                  );
                }}
                label="Decorations"
              />

              {/* <Autocomplete
                label="Decoration"
                value={row?.decoration}
                setValue={(c) => handleLineItemsChange("decoration", c, i)}
                inputValue={row?.decorationInput}
                setInputValue={(v) =>
                  handleLineItemsChange("decorationInput", v, i)
                }
                options={
                  decorations?.map((u) => ({
                    ...u,
                    id: u?.decoCode,
                    label: u?.decoCode,
                  })) || []
                }
              /> */}
            </StyledTableRow2>

            <StyledTableRow2>
              <TextField
                label="Purchase Order"
                value={row?.purchaseOrder}
                handleChange={(e) =>
                  handleLineItemsChange("purchaseOrder", e?.target?.value, i)
                }
              />
            </StyledTableRow2>

            <StyledTableRow2>
              <TextAreaWrapper>
                <p>Additional Information</p>
                <TextareaAutosize
                  label="Additional Information"
                  style={{ width: "98%", backgroundColor: "inherit" }}
                  placeholder="Attention Information"
                  minRows={3}
                  value={row?.additionalInformation}
                  onChange={(e) =>
                    handleLineItemsChange(
                      "additionalInformation",
                      e?.target?.value,
                      i
                    )
                  }
                />
              </TextAreaWrapper>
            </StyledTableRow2>

            <StyledTableRow2>
              <TextField
                label="Decoration Cost"
                // error={!row?.decorationCost}
                value={row?.decorationCost}
                type="number"
                handleChange={(e) => {
                  if (Number(e?.target?.value) < 0) {
                    return;
                  }

                  const decorationCost = Number(e?.target?.value);
                  const qty = Number(row?.qty);
                  const taxPercentage = Number(row?.taxPercentage) || 0;
                  const taxCharged =
                    decorationCost * qty * (taxPercentage / 100);
                  const chargeAmount = decorationCost * qty + taxCharged;
                  setState({
                    ...state,
                    lineItems: lineItems?.map((r, j) => {
                      if (i !== j) return r;
                      return {
                        ...r,
                        decorationCost,
                        taxCharged,
                        chargeAmount,
                      };
                    }),
                  });
                }}
              />

              <TextField
                label="Tax Percentage"
                // error={!row?.taxPercentage}
                value={row?.taxPercentage}
                type="number"
                handleChange={(e) => {
                  if (Number(e?.target?.value) < 0) {
                    return;
                  }

                  const taxPercentage = Number(e.target.value);
                  const decorationCost = Number(row?.decorationCost) || 0;
                  const qty = Number(row?.qty || 0);
                  const taxCharged =
                    decorationCost * qty * (taxPercentage / 100);
                  const chargeAmount = decorationCost * qty + taxCharged;
                  setState({
                    ...state,
                    lineItems: lineItems?.map((r, j) => {
                      if (i !== j) return r;
                      return {
                        ...r,
                        taxPercentage,
                        taxCharged,
                        chargeAmount,
                      };
                    }),
                  });
                }}
              />

              <TextField
                label="Tax Charged"
                disabled
                value={Number(row?.taxCharged || 0).toFixed(2)}
                type="number"
              />

              <TextField
                label="Charge Amount"
                // error={!row?.chargeAmount}
                value={Number(row?.chargeAmount || 0).toFixed(2)}
                disabled
              />
            </StyledTableRow2>

            <div
              style={{
                borderTop: "2px solid #e0e0e0",
                paddingTop: "20px",
                marginTop: "24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                Decorations
              </h3>

              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<AddCircleIcon />}
                onClick={() => {
                  setState({
                    ...state,
                    lineItems: lineItems?.map((r, j) => {
                      if (i !== j) return r;
                      return {
                        ...r,
                        decorations: [
                          ...(r?.decorations || []),
                          { name: "", type: "", image: "" },
                        ],
                      };
                    }),
                  });
                }}
                style={{
                  borderRadius: "6px",
                  textTransform: "none",
                  fontWeight: 500,
                }}
              >
                Add Decoration
              </Button>
            </div>

            {row?.decorations?.map((decoration, j) => (
              <div
                key={`decoration_${key}_${j}`}
                style={{
                  background: "#fafafa",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "20px",
                  margin: "12px 0",
                  position: "relative",
                }}
              >
                {/* Decoration Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  <h4
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  >
                    Decoration {j + 1}
                  </h4>
                  <Button
                    color="error"
                    size="small"
                    variant="outlined"
                    startIcon={<DeleteIcon sx={{ fontSize: 16 }} />}
                    onClick={() => handleDeleteDecoration(i, j)}
                    style={{
                      minWidth: "auto",
                      padding: "4px 8px",
                    }}
                  >
                    Remove
                  </Button>
                </div>

                {/* Form Fields Grid */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    label="Decoration Location"
                    value={decoration?.location || ""}
                    handleChange={(e) =>
                      handleDecorationChange("location", e?.target?.value, i, j)
                    }
                    style={{ width: "100%" }}
                  />

                  <TagsAutocomplete
                    multiple={false}
                    optionApiKey="decoCode"
                    apiEndPoint={DECORATIONS}
                    value={decoration?.type || { title: "", value: "" }}
                    setValue={(decoration) => {
                      handleDecorationChange(
                        "type",
                        {
                          title: decoration?.title || "",
                          value: decoration?.value || "",
                        },
                        i,
                        j
                      );
                    }}
                    label="Decorations"
                  />
                </div>

                {/* Image Upload Section */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#666",
                        marginBottom: "4px",
                      }}
                    >
                      Thumbnail Image
                    </div>
                    <UploadImageWithLibrary
                      apiUrl={THUMB_IMAGE_LIBRARY}
                      uploadedFileType="thumb"
                      url={decoration?.thumbFile?.secure_url}
                      name={decoration?.thumbFile?.original_filename}
                      setUrl={(url) => {
                        handleDecorationChange("thumbFile", url, i, j);
                      }}
                      folder="ConfluenceApp/ManualOrders/ThumbFiles"
                      showPencilIcon={false}
                      size="sm"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#666",
                        marginBottom: "4px",
                      }}
                    >
                      Production File
                    </div>
                    <UploadImageWithLibrary
                      apiUrl={PROD_IMAGE_LIBRARY}
                      uploadedFileType="prod"
                      url={decoration?.productionFile?.secure_url}
                      name={decoration?.productionFile?.original_filename}
                      setUrl={(url) =>
                        handleDecorationChange("productionFile", url, i, j)
                      }
                      folder="ConfluenceApp/ManualOrders/ProdFiles"
                      showPencilIcon={false}
                      size="sm"
                    />
                  </div>
                </div>
              </div>
            ))}
          </StyledTableRow>
        );
      })}
    </Paper>
  );
};

SalesOrderLineItems.propTypes = PROP_TYPES;

SalesOrderLineItems.defaultProps = DEFAULT_STATE;

export default SalesOrderLineItems;
